import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { TextField, SelectField } from 'redux-form-material-ui';
import { getTranslatedString } from 'helpers/i18n';
import validate from './validate';
import MenuItem from 'material-ui/MenuItem';

class PrescreeningMessage extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.propertyFAQTitle')}
            </h3>
            <p style={{ textAlign: 'center', margin: '5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.propertyFAQInfo')}
            </p>
            <Field
              name="property_faq"
              component={TextField}
              hintText={getTranslatedString('landlordPortal.properties.propertyFAQHint')}
              multiLine={true}
              fullWidth
              rows={4}
              style={{ fontSize: '14px' }}
            />
          </div>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.preShowingInstructionsTitle')}
            </h3>
            <p style={{ textAlign: 'center', margin: '5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.preShowingInstructionsInfo')}
            </p>
            <Field
              name="pre_showing_instructions"
              component={TextField}
              hintText={getTranslatedString('landlordPortal.properties.preShowingInstructionsHint')}
              multiLine={true}
              fullWidth
              rows={4}
              style={{ fontSize: '14px' }}
            />
          </div>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.welcomeVideoTitle')}
            </h3>
            <p style={{ textAlign: 'center', margin: '5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.welcomeVideoInfo')}
            </p>
            <Field
              name="welcome_video_link"
              component={TextField}
              hintText={getTranslatedString('landlordPortal.properties.welcomeVideoHint')}
              fullWidth
              style={{ fontSize: '14px' }}
            />
          </div>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.creditCheckPermissions')}
            </h3>
            <p style={{ textAlign: 'center', margin: '5px 0px' }}>
              {getTranslatedString('landlordPortal.properties.creditCheckPermissionsInfo')}
            </p>
            <Field
              name="credit_check_permissions"
              component={SelectField}
              fullWidth
              style={{ fontSize: '14px' }}
            >
              <MenuItem value={'company_defaults'} primaryText={'Company Defaults'} />
              <MenuItem value={'credit_check'} primaryText={'Credit Checks Only'} />
              <MenuItem value={'credit_soft_check'} primaryText={'Credit Checks and Soft Check'} />
              <MenuItem
                value={'us_criminal_check'}
                primaryText={'Credit Checks, Soft Checks, and US Criminal Check'}
              />
            </Field>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PrescreeningMessage);
